// extracted by mini-css-extract-plugin
module.exports = {"searchForPatient_container":"SearchForPatient_searchForPatient_container__1H5P9","patient__block_button":"SearchForPatient_patient__block_button__2iamc"};